export const ZohoListingDeskTicketType = {
  ListingSubmittedForReview: 'listingSubmittedForReview',
  ListingUpdatesRequested: 'listingUpdatesRequested',
  ListingSubmittedWithoutMeasurements: 'listingSubmittedWithoutMeasurements',
  ListingOfferRequested: 'listingOfferRequested',
  BuilderListingRemoval: 'builderListingRemoval',
};

export const ZohoCustomDeskTicketType = {
  HowItWorksBuilder: 'howItWorksBuilder',
  BuilderPendingSaleRemoval: 'builderPendingSaleRemoval',
  OfferAccepted: 'offerAccepted',
};

export default {
  ZohoListingDeskTicketType,
  ZohoCustomDeskTicketType,
};
